import { gql, useMutation } from '@apollo/client';
import { showSuccessFlash } from '../../components-v2/Flash';
import {
  CreateMovementMutation,
  CreateMovementMutationVariables,
  CreateOneSidedMovementMutation,
  CreateOneSidedMovementMutationVariables,
} from '../types';

const CREATE_MOVEMENT = gql`
  mutation CreateMovement($txnIds: [String!]!, $date: DateTime!, $toAccountId: Int!, $fromAccountId: Int!) {
    createMovement(txnIds: $txnIds, date: $date, toAccountId: $toAccountId, fromAccountId: $fromAccountId)
  }
`;

type Args = {
  onSuccess?: () => void;
};

export const useCreateMovement = ({ onSuccess }: Args) => {
  return useMutation<CreateMovementMutation, CreateMovementMutationVariables>(CREATE_MOVEMENT, {
    onCompleted: () => {
      showSuccessFlash('Movement created successfully');
      onSuccess && onSuccess();
    },
  });
};

const CREATE_ONE_SIDED_MOVEMENT = gql`
  mutation CreateOneSidedMovement(
    $txnIds: [String!]!
    $date: DateTime
    $toAccountId: Int!
    $fromAccountId: Int!
  ) {
    createOneSidedMovement(
      txnIds: $txnIds
      date: $date
      toAccountId: $toAccountId
      fromAccountId: $fromAccountId
    )
  }
`;

export const useCreateOneSidedMovement = ({ onSuccess }: Args) => {
  return useMutation<CreateOneSidedMovementMutation, CreateOneSidedMovementMutationVariables>(
    CREATE_ONE_SIDED_MOVEMENT,
    {
      onCompleted: () => {
        showSuccessFlash('Movement created successfully');
        onSuccess && onSuccess();
      },
    },
  );
};
